import { useEffect, useState } from "react";

/** Rows per page in every report table. */
export const REPORT_PAGE_SIZE = 20;

/**
 * One page of rows a report already holds, and the controls to move through
 * them. Back to the first page whenever the rows change — a new filter is a
 * new list, and page 4 of the old one means nothing in it.
 */
export function usePagedRows<T>(rows: T[], pageSize = REPORT_PAGE_SIZE) {
    const [offset, setOffset] = useState(0);

    useEffect(() => setOffset(0), [rows]);

    return {
        page: rows.slice(offset, offset + pageSize),
        offset,
        total: rows.length,
        pageSize,
        onPrev: () => setOffset((current) => Math.max(current - pageSize, 0)),
        onNext: () => setOffset((current) => (current + pageSize < rows.length ? current + pageSize : current)),
    };
}
